import {React, useState, useContext, useEffect} from "react";
import {Link, useNavigate} from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useStyle } from "../../context/styleContext/styleContext";
import Button from '@mui/material/Button';




const RemoveItemsFromCartModal = ({ isOpen, close, itemsToRemove, children, message, buttonText }) => {

    const { style, setStyle } = useStyle();
    const navigate = useNavigate()
  
    if (!isOpen) return null;
    
    const closeFunction = async (e) => {            
                close() 
                navigate('/shopping-cart')

    }



  return ReactDOM.createPortal(


    
    <div style={modalStyle}>
      <div style={modalContentStyle}>
        <div style={{backgroundColor:style.color1, width:'90%', margin:'auto', color:style.color4}}>
            
                    <div style={{display:'flex', flex:1, flexDirection:'column', textAlign:'center', width:'90%', margin:'auto'}}>
                        
                          <>
                          <div style={{marginBottom:'75px', marginTop:'0px'}}>
                            <h1 style={{marginBottom:'30px', fontSize:'2em'}}>
                              You already own the following products:
                            </h1>

                            <div style={{marginBottom:'25px'}}>
                            <strong style={{marginTop:'50px', marginBottom:'25px', fontSize:'1.6em'}}>



                            {itemsToRemove && itemsToRemove.length > 0 && (
                               

                                
                                 itemsToRemove.map((item, index) => (
                                    <li key={index} style={{textAlign:'left'}}>
                                                {  item.name  }
                                    </li>
                                    
                                   
                                ))
                               
                                 )
                                 
                                 }



                                

                                </strong>

                            </div>
                                <div>
                                <strong style={{fontSize:'1.4em'}}>
                                    Please remove them from your cart and try again.
                                </strong>

                                </div>
                                

                               
                            
                            </div>
                            <div>
                                <Button onClick={closeFunction} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color2, fontSize:'14pt', width:'100%', minWidth:'250px', maxWidth:'300px', margin:'auto', marginTop:'0px', borderColor:style.color2, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color3 }, }}>OK</Button>
                            </div>
                              </>
                            

                    </div>
           
            
        </div>
      </div>

    </div>,
    document.getElementById('modal-root')
  );
};

const modalStyle = {

    
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxHeight: '100vh',
  overflowY: 'auto',
  margin:'auto',
  zIndex: "1000",
};

const modalContentStyle = {
  padding: '20px',
  borderRadius: '15px',
  maxWidth: '800px',
  minHeight: '300px',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  width: '90%',
  borderColor:'rgb(39, 55, 77)',
  borderWidth:'2px',
  borderStyle:'solid',
  backgroundColor: 'rgb(39, 55, 77)',
};

const buttonStyle = {
  marginTop: '20px',
  alignSelf: 'center'
};

export default RemoveItemsFromCartModal;
